import React from "react"
import { useTranslation } from "react-i18next"

const number = value => Number.isFinite(value) ? value.toLocaleString("en-GB", { maximumFractionDigits: 1 }) : "Unavailable"
const valueLabel = (value, unit) => Number.isFinite(value)
  ? `${number(value)}${unit === "percentage" ? "%" : unit === "rating" ? " / 5" : ""}` : "Unavailable"
const levelKey = row => [row.sportType, row.gameType, row.officialLevel].join(":")

// One review KPI card: the value, its responses and, outside the compact Dashboard, the comparison period's value.
// `children` adds lines under it (the tournament feedback cards' catalog dates).
export function KpiCard({ metric, compact = false, children }) {
  const { t } = useTranslation("analytics")
  return <div className="col-12 col-sm-6 col-xl">
    <article className="card"><div className="card-body">
      <h3 className="font-size-14">{metric.label}</h3>
      <strong className="font-size-24" title={metric.definition?.summary}>{valueLabel(metric.current.value, metric.unit)}</strong>
      {metric.key === "reviewCompletion" && <p className="mb-0">{metric.current.answered} / {metric.current.possible} verified opportunities</p>}
      {metric.current.count !== undefined && <p className="mb-0">{t("kpiResponses", { count: metric.current.count })}</p>}
      {!compact && <p className="text-muted mb-0">Previous: {valueLabel(metric.comparison.value, metric.unit)}</p>}
      {children}
    </div></article>
  </div>
}

// `children` sit right under the KPI cards (the Dashboard's „Tournament feedback” group).
export default function ReviewsView({ snapshot, compact = false, children }) {
  const current = snapshot.reviews.current
  const previousLevels = new Map(snapshot.reviews.comparison.levels.map(row => [levelKey(row), row]))
  return <section aria-label="Reviews and reputation">
    <div className="row">
      {snapshot.kpis.map(metric => <KpiCard metric={metric} compact={compact} key={metric.key} />)}
    </div>
    {children}
    {(current.coverage.unknownPeriod || current.coverage.unknownOpportunities > 0 || current.coverage.legacyReputationVersions > 0 || current.coverage.unknownFirstSubmissions > 0 || current.coverage.missingLocations > 0) &&
      <p role="status">Historical coverage is incomplete. Unverified opportunities are excluded from counts; completion is unavailable when its denominator cannot be established.</p>}
    <div className="card"><div className="card-body">
      <h3 className="font-size-16">Level balance</h3>
      <div className="table-responsive"><table className="table table-sm mb-0">
        <thead><tr><th>Sport / format</th><th>Official level at source</th><th>Average assessed</th><th>Difference</th><th>Responses</th>{!compact && <th>Previous average</th>}</tr></thead>
        <tbody>{current.levels.map(row => <tr key={levelKey(row)}>
          <td>{row.sportType} · {row.gameType}</td><th scope="row">{row.officialLevel == null ? "Unknown historical level" : `NV ${row.officialLevel}`}</th>
          <td>{number(row.average)}</td><td>{Number.isFinite(row.difference) && row.difference > 0 ? "+" : ""}{number(row.difference)}</td>
          <td>{row.numericCount} numeric · {row.cannotAssessCount} cannot assess</td>
          {!compact && <td>{number(previousLevels.get(levelKey(row))?.average)}</td>}
        </tr>)}</tbody>
      </table></div>
      {!current.levels.length && <p className="mt-3 mb-0">No level assessments in this period.</p>}
    </div></div>
  </section>
}
